import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import MultiParameterSlider from 'components/mix/MultiParameterSlider.js';
import MixesComponent from 'components/mix/MixesComponent.js';
import SingleLFOComponent from 'components/lfo/SingleLFOComponent.js';
import {setShowLFOs} from 'actions/index.js';
import { connect } from "react-redux";
import {LFOS, MIXES, PARAMETERS} from './constants.js';
import {setMixViewMode} from 'actions/index.js';

class MixParametersComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            option: LFOS,
        };

        this.onClickOption = this.onClickOption.bind(this);
    }

    onClickOption(option) {
        this.props.setMixViewMode(option);
    }

    onClickThumbnail() {
        this.props.setShowLFOs(!this.props.showLFOs);
    }

    onClickLock() {
        this.props.lfosTrack.togglePatternLocked();
    }

    render() {
        let className = this.props.isMixView ? 'track flex lfos-track mix-lfo-view' : 'track flex lfos-track';
        return (
            <div></div>
        );
        return (
            <div
              key={'lfo-tracks'}
              onClick={() => []} className={className}>
              <div className=''>
                <MixParameterOption
                  option={LFOS}
                  selectedOption={this.props.mixViewMode}
                  onClickOption={this.onClickOption}/>
                <MixParameterOption
                  option={PARAMETERS}
                  selectedOption={this.props.mixViewMode}
                  onClickOption={this.onClickOption}/>
                <MixParameterOption
                  option={MIXES}
                  selectedOption={this.props.mixViewMode}
                  onClickOption={this.onClickOption}/>
              </div>
              <ConditionedComponent condition={this.props.mixViewMode === PARAMETERS}>
                <MultiParameterSlider
                  id={0}
                  sequencerEngine={this.props.sequencerEngine}/>
                <MultiParameterSlider
                  id={1}
                 sequencerEngine={this.props.sequencerEngine}
                  />
              </ConditionedComponent>
              <ConditionedComponent condition={this.props.mixViewMode === MIXES}>
                <MixesComponent sequencerEngine={this.props.sequencerEngine}/>
              </ConditionedComponent>
              <ConditionedComponent condition={this.props.mixViewMode === LFOS}>
                <div className="effects-view">
                  {this.props.lfosTrack.lfos.map(
                      lfo => 
                  <SingleLFOComponent sequencerEngine={this.props.sequencerEngine} lfo={lfo}/>)}
                </div>
                   <div className="lock-button-container">
                   <img
                   onClick={() => this.onClickLock()}
                   className="lock-button"
                   src={this.props.patternLocked ? "/closed-padlock.png" : "/opened-padlock.png"}/>
                   </div>
 
              </ConditionedComponent>
            </div>
        );
    }
}

class MixParameterOption extends Component {
    render() {
        let className = 'mix-parameters-option';
        if (this.props.option === this.props.selectedOption) {
            className += ' selected';
        }
        return (
            <div onClick={() => this.props.onClickOption(this.props.option)}
              className={className}>
              {this.props.option}
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setShowLFOs: s => dispatch(setShowLFOs(s)),
        setMixViewMode: s => dispatch(setMixViewMode(s)),
    };
};

const mapStateToProps = (state, props) => {
    return {
        mixViewMode: state.mix.mixViewMode,
        showLFOs: state.sequencer.showLFOs,
        patternLocked: state.tracks.lfoPatternLocks[props.sequencerEngine.currentPattern]
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(MixParametersComponent);
